const pricesMatch = (variantPrice, totalPrice) =>
    Math.round(parseFloat(variantPrice)) === Math.round(Number(totalPrice));

const getCurrentVariant = (shopifyReducer, currState) => {
    const variants = shopifyReducer?.currentCiem?.variants || [];
    const total = currState.iemPrice.total;

    return variants.find((option) => pricesMatch(option.price, total));
};

export const findVariantByPrice = (variants, totalPrice) => {
    if (!variants?.length) {
        return undefined;
    }
    return variants.find((option) => pricesMatch(option.price, totalPrice));
};

export default getCurrentVariant;
